import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import * as Types from '../../../../types/api.types.generated.d';
import { ListJobOrderFragmentDoc } from '../listJobOrderFragment/listJobOrderFragment.generated';

const defaultOptions = {} as const;
export type RecommendedJobOrdersQueryVariables = Types.Exact<{ [key: string]: never }>;

export type RecommendedJobOrdersQuery = {
  __typename?: 'Query';
  recommendedJobOrders: Array<{
    __typename?: 'JobOrderHubType';
    jobOrderId: string;
    jobOrderLabel: string;
    assignmentDate?: any | null;
    locationPreference?: string | null;
    workMode?: Types.WorkModeEnum | null;
    rateRangeFrom?: number | null;
    rateRangeTo?: number | null;
    isSaved?: boolean | null;
    seniority?: Types.SeniorityLevelEnum | null;
    experienceYears?: number | null;
    minEnglishLevel?: Types.LanguageLevelEnum | null;
    isAIRAvailable: boolean;
    application?: {
      __typename?: 'JobOrderApplicationHubType';
      applicationId: string;
      jobOrderId: string;
      publicOfferId?: string | null;
      createdAt: string;
      meetingDates: Array<string>;
      ciDate?: string | null;
      cqDate?: string | null;
      status: Types.JobOrderApplicationStatusEnum;
      processStatus: Types.JobOrderApplicationProcessStatusEnum;
      prevProcessStatus?: Types.JobOrderApplicationProcessStatusEnum | null;
      meetingUrl?: string | null;
      isViewedByExpert: boolean;
      handlerId?: string | null;
      preppingId?: string | null;
      flow?: Types.JobOrderApplicationFlowEnum | null;
      contactByPhone?: boolean | null;
      isPreferencesFinished: boolean;
      hasActiveAirInterviewInvitation: boolean;
      preferences?: {
        __typename?: 'JobOrderApplicationPreferencesType';
        location?: string | null;
        workType?: Types.WorkModeEnum | null;
        rateDesired?: number | null;
        linkedInUrl?: string | null;
        availability?: Types.ExpertAvailabilityEnum | null;
        noticeLength?: number | null;
        experienceYears?: number | null;
        englishLevel?: Types.LanguageLevelEnum | null;
        skillsMustHave?: Array<{
          __typename?: 'PreferencesSkillType';
          tagId: string;
          weight: number;
        }> | null;
        skillsNiceToHave?: Array<{
          __typename?: 'PreferencesSkillType';
          tagId: string;
          weight: number;
        }> | null;
      } | null;
    } | null;
  }>;
};

export const RecommendedJobOrdersDocument = gql`
  query recommendedJobOrders {
    recommendedJobOrders {
      ...ListJobOrder
    }
  }
  ${ListJobOrderFragmentDoc}
`;

/**
 * __useRecommendedJobOrdersQuery__
 *
 * To run a query within a React component, call `useRecommendedJobOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecommendedJobOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecommendedJobOrdersQuery({
 *   variables: {
 *   },
 * });
 */
export function useRecommendedJobOrdersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    RecommendedJobOrdersQuery,
    RecommendedJobOrdersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RecommendedJobOrdersQuery, RecommendedJobOrdersQueryVariables>(
    RecommendedJobOrdersDocument,
    options,
  );
}
export function useRecommendedJobOrdersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RecommendedJobOrdersQuery,
    RecommendedJobOrdersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RecommendedJobOrdersQuery, RecommendedJobOrdersQueryVariables>(
    RecommendedJobOrdersDocument,
    options,
  );
}
export function useRecommendedJobOrdersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RecommendedJobOrdersQuery,
        RecommendedJobOrdersQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<RecommendedJobOrdersQuery, RecommendedJobOrdersQueryVariables>(
    RecommendedJobOrdersDocument,
    options,
  );
}
export type RecommendedJobOrdersQueryHookResult = ReturnType<typeof useRecommendedJobOrdersQuery>;
export type RecommendedJobOrdersLazyQueryHookResult = ReturnType<
  typeof useRecommendedJobOrdersLazyQuery
>;
export type RecommendedJobOrdersSuspenseQueryHookResult = ReturnType<
  typeof useRecommendedJobOrdersSuspenseQuery
>;
export type RecommendedJobOrdersQueryResult = Apollo.QueryResult<
  RecommendedJobOrdersQuery,
  RecommendedJobOrdersQueryVariables
>;
export function refetchRecommendedJobOrdersQuery(variables?: RecommendedJobOrdersQueryVariables) {
  return { query: RecommendedJobOrdersDocument, variables };
}
